export const IMAGE_TYPES = {
  CUSTOMER: 'Customer',
  TOUR: 'Tour',
  PROJECT: 'Project',
  HOTSPOT: 'Hotspot',
  MEDIA: 'Media',
  THUMB: 'Thumb',
};
